module.exports = __webpack_public_path__ + "static/media/InfoIcon.80cfa423.svg";